/**
 * Define existing prediggo pages
 */
export enum PrediggoPageEnum {
  pre_produit_recette = 0,
  recherche_nos_recettes = 1,
  recherche_nos_produits = 2,
  navigation_produits_recettes = 3,
  home_page = 4,
  home_recettes = 5,
  page_recette_produits = 6,
  page_404 = 7,
  dcaa_vegetable = 8,
  page_produits = 9,
  recipe_legumiz = 10,
  recherche_nos_articles = 13,
}
